/**
 * Tailwind colors configuration for React components
 * This replaces the old tailwind.config.js import for v4 compatibility
 */

export const tailwindConfig = {
  theme: {
    extend: {
      colors: {
        'rgpd-admin': '#273d50',
        'rgpd-admin-bg': '#f3f4f6',
        'rgpd-red': '#f1416c',
        'rgpd-red-dark': '#d9214e',
        'rgpd-blue': '#0c4295',
        'rgpd-blue-dark': '#0b1755',
        'rgpd-blue-light': '#2884ef',
        'rgpd-white': '#fff',
        'rgpd-green': '#28a745',
        'rgpd-green-light': '#f2fff3',
        'rgpd-green-dark': '#218838',
        'primary': 'var(--color-primary)',
        'secondary': 'var(--color-secondary)',
        'accent': 'var(--color-accent)',
      },
    },
  },
};

export default tailwindConfig;
